import React from 'react';
// Styles provided by RestaurantOnboarding.css

const StepRestaurantContactInfo = ({formData, onUpdate, errors = {}, onClearError}) => {

    const handleChange = (field, value) => {
        onUpdate({[field]: value});
        if (errors[field] && onClearError) onClearError(field);
    };

    /* Mobile: strip non-digits, drop leading 0, cap at 9 chars */
    const handleMobile = (raw) => {
        const digits = raw.replace(/\D/g, '').replace(/^0+/, '').slice(0, 9);
        handleChange('mobile', digits);
    };

    const emailVerified = !!formData.contact_email;
    const mobileVerified = !!(formData.mobile && formData.mobile.length === 9);

    return (
        <div className="ro-body ro-basic">

            <div className="ro-step-hd">
                <span className="ro-eyebrow ro-eyebrow--accent">Paso 4 · Contacto</span>
                <h2 className="ro-title">Información de contacto</h2>
                <p className="ro-subtitle">
                    Estos serán tus canales oficiales dentro de la plataforma.
                </p>
            </div>

            {/* Email de contacto */}
            <div className="ro-field">
                <label className="ro-lbl">
                    Email de contacto<span className="ro-req">*</span>
                </label>
                <div className={`ro-inputwrap${emailVerified ? ' ro-inputwrap--verified' : ''}${errors.contact_email ? ' ro-inputwrap--err' : ''}`}>
                    <span className="ro-inputico" aria-hidden>✉️</span>
                    <input
                        type="email"
                        className="ro-input--clean"
                        placeholder="correo@tudominio.com"
                        value={formData.contact_email || ''}
                        onChange={(e) =>
                            handleChange('contact_email', e.target.value.toLowerCase())
                        }
                        maxLength={254}
                        autoComplete="email"
                        autoCapitalize="none"
                        spellCheck={false}
                        readOnly={emailVerified}
                    />
                    {emailVerified && <span className="ro-verified-badge">✓ Verificado</span>}
                </div>
                {errors.contact_email && (
                    <span className="ro-err-msg">{errors.contact_email}</span>
                )}
                <span className="ro-hint">Recibirás notificaciones de Jama en este correo.</span>
            </div>

            {/* Celular con prefijo Ecuador */}
            <div className="ro-field">
                <label className="ro-lbl">Celular<span className="ro-req">*</span></label>
                <div className={`ro-inputwrap${mobileVerified ? ' ro-inputwrap--verified' : ''}${errors.mobile ? ' ro-inputwrap--err' : ''}`}>
                    <span className="ro-phone-prefix">🇪🇨 +593</span>
                    <input
                        type="tel"
                        inputMode="numeric"
                        className="ro-input--clean"
                        placeholder="Ej.991234567"
                        value={formData.mobile || ''}
                        onChange={(e) => handleMobile(e.target.value)}
                        maxLength={9}
                        readOnly={mobileVerified}
                    />
                    {mobileVerified
                        ? <span className="ro-verified-badge">✓ Verificado</span>
                        : <span className="ro-inputsuffix ro-phone-count">{(formData.mobile || '').length}/9</span>
                    }
                </div>
                {errors.mobile && (
                    <span className="ro-err-msg">{errors.mobile}</span>
                )}
                <span className="ro-hint">Canal de contacto oficial del negocio.</span>
            </div>
            {/* Teléfono fijo + Celular — lado a lado */}
            <div className="ro-field">
                <label className="ro-lbl">Teléfono fijo</label>
                <div className="ro-inputwrap">
                    <span className="ro-phone-prefix" aria-hidden>📞</span>
                    <input
                        type="tel"
                        className="ro-input--clean"
                        placeholder="042-123456"
                        value={formData.phone || ''}
                        onChange={(e) => handleChange('phone', e.target.value)}
                        maxLength={20}
                    />
                </div>
                <span className="ro-hint">Línea telefónica del negocio (opcional).</span>

            </div>
        </div>
    );
};

export default StepRestaurantContactInfo;
